export type OverrideSubmitInFlight = {
  tryAcquire(): boolean;
  release(): void;
};

export function createOverrideSubmitInFlight(): OverrideSubmitInFlight {
  let active = false;
  return {
    tryAcquire() {
      if (active) return false;
      active = true;
      return true;
    },
    release() {
      active = false;
    },
  };
}
